import React, { useState } from 'react'
import MotivationSlider from '../MotivationSlider'
import { ComponentData } from '../../data/ComponentContext'
import { Row } from 'react-bootstrap'
import Col from 'react-bootstrap/Col'
import Delete from '../../img/delete.svg'
import Arrow from '../../img/arrow-right.svg'
import RemainingPointSlider from '../RemainingPointSlider'

function MotivationTab({ toNextTab }) {

  const { Motivations, resetSlider, motivationIsValid } = ComponentData()

  const [displayErrors, setDisplayErrors] = useState(false)

  return (
    <div className='motivation-tab'>
      <div className="content-box">
        <Row>
          <Col xs={6}>
            <h2>Was ist Ihre Motivation?</h2>
            <p>Bitte beschreiben Sie die Motivation Ihres Vorhabens durch die Vergabe von 13 Punkten.</p>
          </Col>
          <Col xs={6}>
            <Row>
              <RemainingPointSlider displayErrors={displayErrors} />
            </Row>
          </Col>
        </Row>
      </div>

      <div className="configuration-area">
        <Row>
          {Object.values(Motivations).map((motivation) => {
            return (
              <MotivationSlider
                key={'slider-' + motivation}
                motivation={motivation} />
            )
          })}
        </Row>

      </div>
      <div className="button-box">
        <button className="delete" onClick={resetSlider}>Zurücksetzen <img className="button-svg" src={Delete} alt='' /></button>
        <button className={motivationIsValid ? '' : 'disabled'} onClick={motivationIsValid ? toNextTab : () => setDisplayErrors(true)}>Weiter <img className="button-svg" src={Arrow} alt='' /></button>
      </div>

    </div>
  )
}

export default MotivationTab
